import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { getAdminNavigationBarMenu } from "src/app/modules/bootstrap/admin-ui/admin-ui.menu";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { getPmsNavigationBarMenu } from "src/app/modules/bootstrap/pms-ui/pms-ui.menu";
import { getPmsSettingsMenu } from "src/app/modules/bootstrap/pms-ui/pms-ui.settings-menu";
import { getNavigationBarMenu } from "src/app/modules/bootstrap/rocket-ui/rocket-ui.menu";
import { getRocketSettingsMenu } from "src/app/modules/bootstrap/rocket-ui/rocket-ui.settings-menu";
import { ConfigurationService } from "src/app/services/configuration.service";
import { RegionService } from "src/app/services/feature-access-control/region.service";
import { FeatureService } from "src/app/services/feature.service";
import { ProductService } from "src/app/services/product.service";
import { UserService } from "src/app/services/user.service";
import { IntegrationService } from "src/app/services/integration.service";
import { SoftwareProduct } from "src/app/support/product";
import { getPlatoformNavigationBarMenu } from "src/app/modules/bootstrap/platform-ui/platform-ui.menu";
import { getBotmasterNavigationBarMenu } from "src/app/modules/domains/dazerolab/products/botmaster/botmaster.menu";

@Injectable()
export class ProvideMenuGuard implements CanActivate {
  private readonly productService = inject(ProductService);
  private readonly bootstrapService = inject(BootstrapService);
  private readonly userService = inject(UserService);
  private readonly featureService = inject(FeatureService);
  private readonly translocoService = inject(TranslocoService);
  private readonly regionService = inject(RegionService);
  private readonly configurationService = inject(ConfigurationService);
  private readonly integrationService = inject(IntegrationService);

  async canActivate(): Promise<boolean> {
    switch (this.productService.getCurrentProduct()) {
      case SoftwareProduct.PLATFORM: {
        await Promise.all([
          this.bootstrapService.setMenu(
            await getPlatoformNavigationBarMenu({})
          ),
          this.bootstrapService.setSettingsMenu([])
        ]);
        break;
      }
      case SoftwareProduct.PMS: {
        await Promise.all([
          this.bootstrapService.setMenu(
            await getPmsNavigationBarMenu({
              regionService: this.regionService,
              featureService: this.featureService,
              userService: this.userService,
              bootstrapService: this.bootstrapService,
              configurationService: this.configurationService,
              integrationService: this.integrationService
            })
          ),
          this.bootstrapService.setSettingsMenu(getPmsSettingsMenu())
        ]);
        break;
      }
      case SoftwareProduct.ROCKET: {
        await Promise.all([
          this.bootstrapService.setMenu(
            getNavigationBarMenu(
              this.bootstrapService
                .getCurrentMember()!
                .roles!.map((x) => x.type),
              {
                userService: this.userService,
                bootstrapService: this.bootstrapService
              }
            )
          ),
          this.bootstrapService.setSettingsMenu(
            getRocketSettingsMenu(
              this.translocoService,
              this.bootstrapService.getCurrentFacilityCode()
            )
          )
        ]);
        break;
      }
      case SoftwareProduct.ADMIN: {
        await Promise.all([
          this.bootstrapService.setMenu(
            getAdminNavigationBarMenu(
              this.bootstrapService
                .getCurrentMember()!
                .roles!.map((x) => x.type),
              {
                userService: this.userService
              }
            )
          ),
          this.bootstrapService.setSettingsMenu(
            getRocketSettingsMenu(
              this.translocoService,
              this.bootstrapService.getCurrentFacilityCode()
            )
          )
        ]);
        break;
      }
      case SoftwareProduct.SNOOTS: {
        break;
      }
      case SoftwareProduct.BOTMASTER: {
        await Promise.all([
          this.bootstrapService.setMenu(
            getBotmasterNavigationBarMenu(
              (this.bootstrapService.getCurrentMember()
                ? this.bootstrapService.getCurrentMember()!.roles || []
                : []
              ).map((x: any) => x.type),
              {
                userService: this.userService,
                bootstrapService: this.bootstrapService
              }
            )
          ),
          this.bootstrapService.setSettingsMenu([])
        ]);
        break;
      }
    }

    return true;
  }
}
